import { render } from "./QuestionAnswerBox.vue?vue&type=template&id=a3d0d7be&scoped=true"
import script from "./QuestionAnswerBox.vue?vue&type=script&lang=js"
export * from "./QuestionAnswerBox.vue?vue&type=script&lang=js"

import "./QuestionAnswerBox.vue?vue&type=style&index=0&id=a3d0d7be&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3d0d7be"]])

export default __exports__